/**
 *
 * Asynchronously loads the component for AnswerImageUpload
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
